<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isPromptActiveLocal"
  >
    <div class="flex items-center justify-between px-6 form-header">
      <h4>Ajouter un stream</h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isPromptActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <VuePerfectScrollbar
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="p-6">
        <div class="vx-row mt-4">
          <div class="w-full">
            <p class="label">Stream</p>
            <v-select
              class="w-full"
              label="name"
              placeholder="Selectionner"
              :options="streams"
              :reduce="(stream) => stream.id"
              v-model="form.stream"
            ></v-select>
          </div>
          <div class="w-full mt-4 px-2">
            <p class="label">Nombre de question pour le stream</p>
            <vs-input-number
              min="1"
              color="#FFCC00"
              v-model="form.nbr_question"
            />
          </div>
        </div>
      </div>
    </VuePerfectScrollbar>
    <div class="p-2" slot="footer">
      <div class="footer mr-6">
        <vs-row vs-justify="flex-end">
          <vs-button class="black-button" @click="isPromptActiveLocal = false"
            >Annuler</vs-button
          >
          <vs-button
            :disabled="form.nbr_question == 0 || form.stream == null ? true : false"
            class="ml-2 text-dark action-button"
            @click="addStream"
            >Ajouter</vs-button
          >
        </vs-row>
      </div>
    </div>
  </vs-sidebar>
</template>

<script>
const default_form = {
  stream: null,
  nbr_question: 0
};
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  name: "AddStreamEvaluation",
  components: { VuePerfectScrollbar },
  props: {
    isPromptActive: {
      type: Boolean,
      required: true,
    },
    callBackAddStream: {
      type: Function,
    },
    streams: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      form: {
        stream: null,
        nbr_question: 0,
      },
      settings: {
        maxScrollbarLength: 40,
        wheelSpeed: 0.6,
      },
    };
  },

  watch: {
    isPromptActive(val) {
      if (!val) return;
    },
  },
  computed: {
    isPromptActiveLocal: {
      get() {
        if (this.isPromptActive) {
          this.form = { ...default_form };
        }
        return this.isPromptActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closePrompt");
        }
      },
    },
  },
  mounted() {},

  methods: {
    addStream(){
      this.$emit("closePrompt");
      this.callBackAddStream(this.form);
    }
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    max-width: 381px !important;
  }

  .form-header {
    background-color: #f8f8f8;
    height: 54px;
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}

.footer {
  button {
    /* Auto layout */
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border-radius: 25px;
    background: transparent !important;
  }

  .black-button {
    border: 1px solid black;
    background: transparent !important;
    color: black;
  }
  .action-button {
    background: #ffcc00 !important;
  }
}
</style>